import Default from "./default";
import ko from "./ko";
import zh from "./zh";
export default {ko, zh, default: Default};
